import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const formatCurrency = (value) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(value || 0);

const MonthlyFlowChart = ({ data = [] }) => {
  const chartData = {
    labels: data.map((item) => item.label),
    datasets: [
      {
        label: "Approved Deposits",
        data: data.map((item) => item.deposits),
        backgroundColor: "rgba(42, 245, 152, 0.7)",
        borderColor: "#2AF598",
        borderWidth: 1,
        borderRadius: 6,
      },
      {
        label: "Paid Withdrawals",
        data: data.map((item) => item.withdrawals),
        backgroundColor: "rgba(245, 42, 45, 0.68)",
        borderColor: "#F52A2D",
        borderWidth: 1,
        borderRadius: 6,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "index", intersect: false },
    plugins: {
      legend: {
        labels: { color: "#fff", usePointStyle: true, padding: 16 },
      },
      tooltip: {
        backgroundColor: "rgba(0, 0, 0, 0.86)",
        titleColor: "#fff",
        bodyColor: "#fff",
        borderColor: "#2AF598",
        borderWidth: 1,
        callbacks: {
          label: (context) => `${context.dataset.label}: ${formatCurrency(context.parsed.y)}`,
        },
      },
    },
    scales: {
      x: {
        grid: { color: "rgba(255, 255, 255, 0.08)", drawBorder: false },
        ticks: { color: "#aaa", maxRotation: 45, minRotation: 0 },
      },
      y: {
        grid: { color: "rgba(255, 255, 255, 0.08)", drawBorder: false },
        ticks: { color: "#aaa", callback: (value) => `$${Number(value / 1000).toFixed(0)}K` },
      },
    },
  };

  return <Bar data={chartData} options={options} />;
};

export default MonthlyFlowChart;
